import {Body} from 'shells/typography/body';

import type {LeadStatus} from 'nutshell-graphql-types';

import {DataFieldWrapper} from '../../../core-entity/widgets/summary-widget/data-field-wrapper';

type Props = {
    outcome: Extract<LeadStatus, 'CANCELLED' | 'LOST'>;
    reason: string;
};

export function LeadOutcomeReason(props: Props) {
    return (
        <DataFieldWrapper
            label={props.outcome === 'CANCELLED' ? 'Cancel reason' : 'Lost reason'}
            children={<Body>{props.reason}</Body>}
        />
    );
}
